import { render, staticRenderFns } from "./FantasyStandard.vue?vue&type=template&id=2fc798a8&scoped=true&"
import script from "./FantasyStandard.vue?vue&type=script&lang=js&"
export * from "./FantasyStandard.vue?vue&type=script&lang=js&"
import style0 from "./FantasyStandard.vue?vue&type=style&index=0&id=2fc798a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc798a8",
  null
  
)

/* custom blocks */
import block0 from "./FantasyStandard.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports